import React from 'react'

import NowOrLater from './components/NowOrLater'
import {
  useActions,
  useMutations,
  useQueryParams,
  useState,
  useVertical,
} from 'src/hooks'
import { AffiliateForm } from 'src/marketing/plans/components'
import { AffiliateFormInfo } from 'src/marketing/plans/components/AffiliateForm/AffiliateForm'
import AffiliateSuccess from './components/AffiliateSuccess'
import { StepWrapperProps } from '../components/ProgressiveProfileActions'

type Step =
  | { type: 'nowOrLater' }
  | { type: 'affiliateForm' }
  | { type: 'affiliateSuccess' }

type TrialAffiliateProfileProps = StepWrapperProps & {
  onComplete: () => void
}

const TrialAffiliateProfile = (props: TrialAffiliateProfileProps) => {
  const { onComplete } = props
  const [step, setStep] = useState<Step>({ type: 'nowOrLater' })
  const actions = useActions()
  const mutations = useMutations()
  const vertical = useVertical()
  const queryParams = useQueryParams()
  const submitAffiliateForm = async (data: AffiliateFormInfo) => {
    const { govId1 } = data
    const {
      createDistributor: { account },
    } = await mutations.createAffiliate({
      account: {
        shippingAddress: { ...data.user },
        firstName: data.user.firstName,
        lastName: data.user.lastName,
      },
      govId1,
      verticalId: vertical.graphqlVerticalID,
      queryParams,
    })
    if (account) {
      actions.updatedAccount(account)
    }
    setStep({ type: 'affiliateSuccess' })
  }

  return (
    <>
      {step.type === 'nowOrLater' && (
        <NowOrLater onNow={() => setStep({ type: 'affiliateForm' })} />
      )}
      {step.type === 'affiliateForm' && (
        <AffiliateForm
          close={() => setStep({ type: 'nowOrLater' })}
          purchase={submitAffiliateForm}
          isTrialAffiliate={true}
        />
      )}
      {step.type === 'affiliateSuccess' && (
        <AffiliateSuccess onClose={onComplete} />
      )}
    </>
  )
}
export default TrialAffiliateProfile
